export class Player {

}

export class Sprite {
    x = 0;
    y = 0;
    sizeX = 0;
    sizeY = 0;
    heightX = 0;
    heightY = 0;
    image = new Image();
    isAnimated = false;
    removeAfterAnimation = false;
    frames = 0;
    framesCounter = 0;
}

export class Wall {
    x = 0;
    y = 0;
}

export class Explosion extends Sprite {
  constructor (x, y) {
    super()
    this.x = x
    this.y = y
    this.sizeX = 50
    this.sizeY = 50
    this.heightX = 256
    this.heightY = 256
    this.image = new Image()
    this.isAnimated = true
    this.removeAfterAnimation = true
    this.frames = 32
    this.framesCounter = 0

    this.image.src = require('@/assets/sprite/explosion.png')
  }
}
